import { Component, ChangeDetectorRef, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm, FormGroup } from '@angular/forms';
import { BuilderTask, BuilderControl, BuilderModel, BuilderField } from '../../models/builder.model';
import { BuilderHelper } from '../../../shared/BuilderHelper';
import { BuilderService } from '../../../dnd/services/builder.service';
import { FormBuilderHelper } from '../../../shared/helper';

@Component({
  selector: 'fb-form-tab',
  templateUrl: './form-tab.component.html',
  styleUrls: ['./form-tab.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FBFormTabComponent implements AfterViewInit {
  @Input() set task(task: BuilderTask) {
    this._task = task;
  }
  @Input() set control(control: BuilderControl) {
    this._control = control;
  }
  @Input() set group(group: FormGroup) {
    this._group = group;
  }
  @Input() set tabIndex(tabIndex: number) {
    this._tabIndex = tabIndex;
  }
  @Input()
  set availableModels(model: BuilderModel) {
    if (JSON.stringify(this._availableModels) === JSON.stringify(model)) {
      return;
    }
    this._availableModels = model;
    this.setupModel();
  }

  get availableModels() {
    return this._availableModels;
  }

  get missingFieldsDebug() {
    return true;
  }

  get control() {
    return this._control;
  }

  get group() {
    return this._group;
  }

  get tabIndex() {
    return this._tabIndex;
  }

  get activeModel() {
    return this._activeModel || this.control;
  }

  get wrongElement() {
    return !this.control || (!this.control.hasOwnProperty('name') && !this.control.hasOwnProperty('controlType'));
  }

  get isSection() {
    return FormBuilderHelper.IsSection(this.control);
  }

  get newRow() {
    return [];
  }

  get activeDragging() {
    return this.builderService.anyActiveDragging;
  }

  get draggedModel() {
    return this.builderService.draggedModel;
  }

  get isRowActive() {
    return (this.draggedModel && this.draggedModel.cells) || (this.draggedModel.template && this.draggedModel.template.cells);
  }

  constructor(protected ref: ChangeDetectorRef, private builderService: BuilderService) {}
  protected _task: BuilderTask;

  protected _control: BuilderControl;

  protected _group: FormGroup;

  protected _tabIndex: number;

  private _activeModel: BuilderField;
  private _availableModels: BuilderModel;

  @Output('onTemplateAdded') templateAddEvent = new EventEmitter<any>();

  ngAfterViewInit() {
    this.setupModel();
  }

  onDrop(event, rowIndex) {
    if (!(rowIndex >= 0) || !this.activeModel || !this.activeModel.rows) {
      return;
    }
    const isRowDropped = event && event.value && event.value.template && event.value.template.cells;
    if (isRowDropped) {
      return this.onRowDropped(event.value.template, rowIndex);
    }
  }

  onRowDropped(row, index) {
    this.activeModel.rows = [
      ...this.activeModel.rows.slice(0, index),
      row,
      ...this.activeModel.rows.slice(index, this.activeModel.rows.length),
    ];
  }
  onTemplateAdded(template) {
    if (!template) {
      return;
    }
    this.templateAddEvent.emit(template);
  }

  fieldType(type: number | string): string {
    return BuilderHelper.ControlType(type);
  }

  controlGroupType(type: number | string): string {
    return BuilderHelper.ControlGroupType(type);
  }

  columnsClass(control: BuilderControl) {
    const columnsCount = control.cells && control.cells.length;
    let rowSpanned = 0;
    control.cells.forEach(cell => {
      if (cell.rowSpan > 1) {
        rowSpanned += Number(cell.rowSpan);
      }
    });
    return `fb-col fb-columns-${columnsCount + rowSpanned} ${rowSpanned ? `fb-original-columns-${columnsCount}` : ''}`;
  }

  private setupModel() {
    if (!this.availableModels) {
      this.availableModels = this.builderService.availableModels;
    }
    if (!(this.availableModels || {})['fieldCollection'] || !(this.control || {})['name'] || this.isSection) {
      return;
    }
    this._activeModel = this.availableModels.fieldCollection.find((field: BuilderField) => field.name === this.control.name);
    return this._activeModel;
  }
}
